// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZeroCostWorkplaceVendingRouteImport } from './routes/zero-cost-workplace-vending'
import { Route as VerificationStatusRouteImport } from './routes/verification-status'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as VendingMachinesRouteImport } from './routes/vending-machines'
import { Route as VendingMachinePlacementRouteImport } from './routes/vending-machine-placement'
import { Route as VendingMachineCostRouteImport } from './routes/vending-machine-cost'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as SeoDashboardRouteImport } from './routes/seo-dashboard'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as QualifyForFreeVendingMachineRouteImport } from './routes/qualify-for-free-vending-machine'
import { Route as HubsRouteImport } from './routes/hubs'
import { Route as FreeVendingMachinesUsaRouteImport } from './routes/free-vending-machines-usa'
import { Route as FreeVendingMachinePlacementRouteImport } from './routes/free-vending-machine-placement'
import { Route as FreeOfficeVendingMachinePlacementRouteImport } from './routes/free-office-vending-machine-placement'
import { Route as FreeMicroMarketPlacementRouteImport } from './routes/free-micro-market-placement'
import { Route as DnsWizardRouteImport } from './routes/dns-wizard'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AskAmyRouteImport } from './routes/ask-amy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StatesStateRouteImport } from './routes/states.$state'
import { Route as IndustriesIndustryRouteImport } from './routes/industries.$industry'
import { Route as ResourcesSlugRouteImport } from './routes/resources.$slug'
import { Route as HubsHubRouteImport } from './routes/hubs.$hub'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as StatesCaliforniaSanFranciscoRouteImport } from './routes/states.california.san-francisco'
import { Route as StatesStateTownRouteImport } from './routes/states.$state.$town'
import { Route as IndustriesIndustryStateRouteImport } from './routes/industries.$industry.$state'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminSuppressionsRouteImport } from './routes/_authenticated/admin.suppressions'
import { Route as AuthenticatedAdminLeadsRouteImport } from './routes/_authenticated/admin.leads'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin.emails'
import { Route as AuthenticatedAdminAmyRouteImport } from './routes/_authenticated/admin.amy'
import { Route as StatesCaliforniaSanFranciscoNeighborhoodRouteImport } from './routes/states.california.san-francisco.$neighborhood'
import { Route as StatesStateTownAreaRouteImport } from './routes/states.$state.$town.$area'

const ZeroCostWorkplaceVendingRoute = ZeroCostWorkplaceVendingRouteImport.update({
            id: '/zero-cost-workplace-vending',path: '/zero-cost-workplace-vending',getParentRoute: () => rootRouteImport
          })
const VerificationStatusRoute = VerificationStatusRouteImport.update({
            id: '/verification-status',path: '/verification-status',getParentRoute: () => rootRouteImport
          })
const VerificationRoute = VerificationRouteImport.update({
            id: '/verification',path: '/verification',getParentRoute: () => rootRouteImport
          })
const VendingMachinesRoute = VendingMachinesRouteImport.update({
            id: '/vending-machines',path: '/vending-machines',getParentRoute: () => rootRouteImport
          })
const VendingMachinePlacementRoute = VendingMachinePlacementRouteImport.update({
            id: '/vending-machine-placement',path: '/vending-machine-placement',getParentRoute: () => rootRouteImport
          })
const VendingMachineCostRoute = VendingMachineCostRouteImport.update({
            id: '/vending-machine-cost',path: '/vending-machine-cost',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const SeoDashboardRoute = SeoDashboardRouteImport.update({
            id: '/seo-dashboard',path: '/seo-dashboard',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const QualifyForFreeVendingMachineRoute = QualifyForFreeVendingMachineRouteImport.update({
            id: '/qualify-for-free-vending-machine',path: '/qualify-for-free-vending-machine',getParentRoute: () => rootRouteImport
          })
const HubsRoute = HubsRouteImport.update({
            id: '/hubs',path: '/hubs',getParentRoute: () => rootRouteImport
          })
const FreeVendingMachinesUsaRoute = FreeVendingMachinesUsaRouteImport.update({
            id: '/free-vending-machines-usa',path: '/free-vending-machines-usa',getParentRoute: () => rootRouteImport
          })
const FreeVendingMachinePlacementRoute = FreeVendingMachinePlacementRouteImport.update({
            id: '/free-vending-machine-placement',path: '/free-vending-machine-placement',getParentRoute: () => rootRouteImport
          })
const FreeOfficeVendingMachinePlacementRoute = FreeOfficeVendingMachinePlacementRouteImport.update({
            id: '/free-office-vending-machine-placement',path: '/free-office-vending-machine-placement',getParentRoute: () => rootRouteImport
          })
const FreeMicroMarketPlacementRoute = FreeMicroMarketPlacementRouteImport.update({
            id: '/free-micro-market-placement',path: '/free-micro-market-placement',getParentRoute: () => rootRouteImport
          })
const DnsWizardRoute = DnsWizardRouteImport.update({
            id: '/dns-wizard',path: '/dns-wizard',getParentRoute: () => rootRouteImport
          })
const CoverageRoute = CoverageRouteImport.update({
            id: '/coverage',path: '/coverage',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AskAmyRoute = AskAmyRouteImport.update({
            id: '/ask-amy',path: '/ask-amy',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StatesStateRoute = StatesStateRouteImport.update({
            id: '/states/$state',path: '/states/$state',getParentRoute: () => rootRouteImport
          })
const IndustriesIndustryRoute = IndustriesIndustryRouteImport.update({
            id: '/industries/$industry',path: '/industries/$industry',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ResourcesRoute
          })
const HubsHubRoute = HubsHubRouteImport.update({
            id: '/$hub',path: '/$hub',getParentRoute: () => HubsRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const StatesCaliforniaSanFranciscoRoute = StatesCaliforniaSanFranciscoRouteImport.update({
            id: '/states/california/san-francisco',path: '/states/california/san-francisco',getParentRoute: () => rootRouteImport
          })
const StatesStateTownRoute = StatesStateTownRouteImport.update({
            id: '/$town',path: '/$town',getParentRoute: () => StatesStateRoute
          })
const IndustriesIndustryStateRoute = IndustriesIndustryStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => IndustriesIndustryRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSuppressionsRoute = AuthenticatedAdminSuppressionsRouteImport.update({
            id: '/suppressions',path: '/suppressions',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLeadsRoute = AuthenticatedAdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAmyRoute = AuthenticatedAdminAmyRouteImport.update({
            id: '/amy',path: '/amy',getParentRoute: () => AuthenticatedAdminRoute
          })
const StatesCaliforniaSanFranciscoNeighborhoodRoute = StatesCaliforniaSanFranciscoNeighborhoodRouteImport.update({
            id: '/$neighborhood',path: '/$neighborhood',getParentRoute: () => StatesCaliforniaSanFranciscoRoute
          })
const StatesStateTownAreaRoute = StatesStateTownAreaRouteImport.update({
            id: '/$area',path: '/$area',getParentRoute: () => StatesStateTownRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAmyRoute: AuthenticatedAdminAmyRoute,AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute,AuthenticatedAdminLeadsRoute: AuthenticatedAdminLeadsRoute,AuthenticatedAdminSuppressionsRoute: AuthenticatedAdminSuppressionsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const HubsRouteChildren = {
  HubsHubRoute: HubsHubRoute
}

const HubsRouteWithChildren = HubsRoute._addFileChildren(HubsRouteChildren)




const ResourcesRouteChildren = {
  ResourcesSlugRoute: ResourcesSlugRoute
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(ResourcesRouteChildren)




const IndustriesIndustryRouteChildren = {
  IndustriesIndustryStateRoute: IndustriesIndustryStateRoute
}

const IndustriesIndustryRouteWithChildren = IndustriesIndustryRoute._addFileChildren(IndustriesIndustryRouteChildren)




const StatesStateTownRouteChildren = {
  StatesStateTownAreaRoute: StatesStateTownAreaRoute
}

const StatesStateTownRouteWithChildren = StatesStateTownRoute._addFileChildren(StatesStateTownRouteChildren)



const StatesStateRouteChildren = {
  StatesStateTownRoute: StatesStateTownRouteWithChildren
}

const StatesStateRouteWithChildren = StatesStateRoute._addFileChildren(StatesStateRouteChildren)




const StatesCaliforniaSanFranciscoRouteChildren = {
  StatesCaliforniaSanFranciscoNeighborhoodRoute: StatesCaliforniaSanFranciscoNeighborhoodRoute
}

const StatesCaliforniaSanFranciscoRouteWithChildren = StatesCaliforniaSanFranciscoRoute._addFileChildren(StatesCaliforniaSanFranciscoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AskAmyRoute: AskAmyRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,CoverageRoute: CoverageRoute,DnsWizardRoute: DnsWizardRoute,FreeMicroMarketPlacementRoute: FreeMicroMarketPlacementRoute,FreeOfficeVendingMachinePlacementRoute: FreeOfficeVendingMachinePlacementRoute,FreeVendingMachinePlacementRoute: FreeVendingMachinePlacementRoute,FreeVendingMachinesUsaRoute: FreeVendingMachinesUsaRoute,HubsRoute: HubsRouteWithChildren,QualifyForFreeVendingMachineRoute: QualifyForFreeVendingMachineRoute,ResourcesRoute: ResourcesRouteWithChildren,SeoDashboardRoute: SeoDashboardRoute,SitemapRoute: SitemapRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,VendingMachineCostRoute: VendingMachineCostRoute,VendingMachinePlacementRoute: VendingMachinePlacementRoute,VendingMachinesRoute: VendingMachinesRoute,VerificationRoute: VerificationRoute,VerificationStatusRoute: VerificationStatusRoute,ZeroCostWorkplaceVendingRoute: ZeroCostWorkplaceVendingRoute,IndustriesIndustryRoute: IndustriesIndustryRouteWithChildren,StatesStateRoute: StatesStateRouteWithChildren,StatesCaliforniaSanFranciscoRoute: StatesCaliforniaSanFranciscoRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)